export interface UserPermissions {
  createCampaign: boolean;
}

export const defaultPermissions: UserPermissions = {
  createCampaign: false,
};
